import { createApp } from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { ThemeDefinition, createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// import { OhVueIcon, addIcons } from 'oh-vue-icons'
// import { FaLinux } from 'oh-vue-icons/icons'

// addIcons(FaLinux)

const roboStockDarkTheme: ThemeDefinition = {
  dark: true,
  variables: {},
  colors: {
    background: '#1a1a1a', // Very dark neutral gray
    surface: '#262626', // Slightly lighter dark gray
    primary: '#cc5200', // Darkened orange (tie and chart bar color)
    'primary-darken-1': '#993d00', // Even darker orange
    secondary: '#007ea6', // Darkened blue (robot's glasses reflection)
    'secondary-darken-1': '#005f7d', // Even darker blue
    error: '#b33a3a', // Darkened red for error
    info: '#0077cc', // Darker blue for informational messages
    success: '#00804d', // Dark green for success
    warning: '#b38f00' // Muted yellow for warning
  }
}

const veutify = createVuetify({
  theme: {
    defaultTheme: 'roboStockDarkTheme',
    themes: { roboStockDarkTheme }
  },
  components: {
    ...components
  },
  directives
})

// const theme = useTheme()
// theme.global.name.value = 'synthWaveTheme'

createApp(App).use(store).use(router).use(veutify).mount('#app')
// .component('v-ov-icon', OhVueIcon)
